// Configuration constants for the application
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://presale-mvp-production.staydot8.workers.dev',
} as const;

export const PAYMENT_CONFIG = {
  // Polling configuration
  POLLING_BASE_INTERVAL: 5000, // 5 seconds
  POLLING_MAX_RETRIES: 10,
  POLLING_BACKOFF_CAP: 5, // Cap exponential backoff at 5x multiplier

  // Rate limiting
  RATE_LIMIT_DURATION: 1000, // 1 second

  // UI timeouts
  CLIPBOARD_SUCCESS_TIMEOUT: 3000, // 3 seconds
  CLIPBOARD_ERROR_TIMEOUT: 2000, // 2 seconds

  // Session expiry check interval
  SESSION_EXPIRY_CHECK_INTERVAL: 1000, // 1 second

  // Form validation
  MIN_PAYMENT_AMOUNT: 0.01,
  MAX_PAYMENT_AMOUNT: 10000,
} as const;

export const ANALYTICS_EVENTS = {
  PAYMENT_SESSION_CREATE_ATTEMPTED: 'payment_session_create_attempted',
  PAYMENT_SESSION_CREATED: 'payment_session_created',
  PAYMENT_SESSION_CREATE_FAILED: 'payment_session_create_failed',
  PAYMENT_COMPLETED: 'payment_completed',
  WALLET_PREFILL_ATTEMPTED: 'wallet_prefill_attempted',
  WALLET_PREFILL_SUCCESS: 'wallet_prefill_success',
  WALLET_PREFILL_FAILED: 'wallet_prefill_failed',
  QR_FALLBACK_SHOWN: 'qr_fallback_shown',
  TRANSACTION_BROADCASTED: 'transaction_broadcasted',
} as const;


